import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const feedFrame = document.getElementById("feed_content")
    if (feedFrame) {
      feedFrame.addEventListener("turbo:frame-load", () => {
        feedFrame.classList.remove("feed-content--loading")
      })
    }
  }

  activate(event) {
    this.element.querySelectorAll(".feed-tab").forEach(tab => {
      tab.classList.remove("feed-tab--active")
    })
    event.currentTarget.classList.add("feed-tab--active")

    const feedFrame = document.getElementById("feed_content")
    if (feedFrame) {
      feedFrame.classList.add("feed-content--loading")
    }
  }
}
